export const getPageName = (pathname: string): string => {
  if (pathname === '/overview') {
    return 'Protocol';
  }

  if (pathname === '/faucet') {
    return 'BTC Faucet';
  }

  if (pathname === '/liquidations') {
    return 'Liquidations';
  }

  if (pathname === '/governance') {
    return 'Governance';
  }

  if (pathname === '/quanta') {
    return 'Earn Quanta';
  }

  if (pathname === '/quanta/missions') {
    return 'Missions';
  }

  if (pathname === '/quanta/side-missions') {
    return 'Side Missions';
  }

  if (pathname === '/quanta/leaderboard') {
    return 'Leaderboard';
  }

  return 'Vault';
};
